import * as e from "react";
import { useSyncExternalStore as t } from "./designsystem-ui-react197.js";
import { useSyncExternalStore as o } from "./designsystem-ui-react198.js";
const r = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", a = !r, d = a ? o : t, i = "useSyncExternalStore" in e ? ((n) => n.useSyncExternalStore)(e) : d;
export {
  i as useSyncExternalStore
};
